import PropTypes from 'prop-types';
// New version of react-intl doen't have the propTypes intlShape anymore
// So we create our own based on the old version:
// https://github.com/formatjs/formatjs/blob/2.x/src/types.js
const { string, func, object, shape, any } = PropTypes;
const funcReq = func.isRequired;
const intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func,
};
const intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelativeTime: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
};
const intlShape = shape({
  ...intlConfigPropTypes,
  ...intlFormatPropTypes,

  // eslint-disable-next-line react/forbid-prop-types
  formatters: object,
});

export default intlShape;
